import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

export default function ProtectedRoute({ isLogged }) {
    if (localStorage.currentUser && localStorage.session)
        return <Outlet />
    else return <Navigate to='/' />
}
